export function classes(...classList) {
  try {
    const classes2 = classList.map((className) => {
      const isNotPresent = [null, void 0, ""].includes(className);
      if (isNotPresent) {
        return null;
      }
      if (className && typeof className === "string")
        return className;
      if (typeof className === "object" && !(className instanceof Array)) {
        return Object.keys(className).filter((classKey) => className[classKey]).join(" ");
      }
      return null;
    });
    return classes2.filter((c) => c).join(" ");
  } catch (err) {
    console.error(`ERROR: classes error: ${err}`);
  }
}
